var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_578)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2098.36 1096.83V-393.867L910.164 -729.451L-278.033 -393.867V1096.83L910.164 1432.43L2098.36 1096.83Z",
    fill: "url(#paint0_linear_5_578)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4,
    d: "M-266.112 764.601V1098.99L325.006 1266.21L916.123 1098.99V764.601L325.006 597.39L-266.112 764.601Z",
    fill: "url(#paint1_linear_5_578)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4,
    d: "M-266.112 430.193V764.586L325.006 931.798L916.123 764.586V430.193L325.006 262.981L-266.112 430.193Z",
    fill: "url(#paint2_linear_5_578)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4,
    d: "M1507.24 263.069V597.459L916.123 764.674L325.005 597.459V263.069L916.123 95.8561L1507.24 263.069Z",
    fill: "url(#paint3_linear_5_578)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4,
    d: "M916.123 1098.99V764.601L1507.24 597.39L2098.36 764.601V1098.99L1507.24 1266.21L916.123 1098.99Z",
    fill: "url(#paint4_linear_5_578)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4,
    d: "M2098.36 430.193V764.586L1507.24 931.798L916.123 764.586V430.193L1507.24 262.981L2098.36 430.193Z",
    fill: "url(#paint5_linear_5_578)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4,
    d: "M1507.24 1266.28V931.885L916.123 764.674L325.005 931.885V1266.28L916.123 1433.49L1507.24 1266.28Z",
    fill: "url(#paint6_linear_5_578)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_578",
    x1: -525.204,
    y1: 136.352,
    x2: 679.898,
    y2: 2125.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF008E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_578",
    x1: 325.006,
    y1: 1250.83,
    x2: 148.725,
    y2: 638.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8257E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF008E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_578",
    x1: 325.006,
    y1: 916.42,
    x2: 148.725,
    y2: 304.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8257E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF008E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_578",
    x1: 325.006,
    y1: 244.275,
    x2: 966.986,
    y2: 1032.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF008E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_578",
    x1: 2098.36,
    y1: 1117.79,
    x2: 1456.38,
    y2: 329.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF008E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_578",
    x1: 1507.24,
    y1: 916.42,
    x2: 1683.52,
    y2: 304.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8257E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF008E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_578",
    x1: 916.123,
    y1: 780.051,
    x2: 1092.4,
    y2: 1392.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8257E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF008E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.eda21191f80736e01858e2997e2f369f.svg";
export { ForwardRef as ReactComponent };